import React from 'react';
import Page from '../../layout/Page';
import PushNotifications from './PushNotifications';
import Button from '../../forms/Button';
import RoleProtected, { userRoles } from '../../RoleProtected';
import { releaseAllDeviceIDs } from './actions';

const PushNotificationsPage = () => (
    <RoleProtected roles={userRoles.notifications}>
        <Page
            title='Push Notifications'
            icon='mobile'
            controls={<Button roles={userRoles.admin} onClick={releaseAllDeviceIDs}>Release All Device IDs</Button>}
        >
            <PushNotifications />
        </Page>
    </RoleProtected>
);

export default PushNotificationsPage;
